/* ── HERO SWIPER ─────────────────────── */
(function initHero() {
  const el = document.getElementById('heroSwiper');
  if (!el) return;

  const heroSwiper = new Swiper('#heroSwiper', {
    loop: true,
    speed: 900,
    autoplay: { delay: 5500, disableOnInteraction: false },
    effect: 'fade',
    fadeEffect: { crossFade: true },
    on: {
      slideChange() {
        const realIdx = this.realIndex;
        document.querySelectorAll('.hero-dot').forEach((d, i) => {
          d.classList.toggle('active', i === realIdx);
        });
      }
    }
  });

  // Generar dots dinámicamente según slides reales
  const dotsWrap = document.getElementById('heroDots');
  if (dotsWrap) {
    const total = el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length;
    for (let i = 0; i < total; i++) {
      const dot = document.createElement('div');
      dot.className = 'hero-dot' + (i === 0 ? ' active' : '');
      dot.dataset.index = i;
      dot.addEventListener('click', () => heroSwiper.slideToLoop(i));
      dotsWrap.appendChild(dot);
    }
  }
})();

/* ── PRODUCT SWIPER ──────────────────── */
(function initProd() {
  if (!document.getElementById('prodSwiper')) return;
  new Swiper('#prodSwiper', {
    slidesPerView: 4,
    spaceBetween: 24,
    grabCursor: true,
    breakpoints: {
      0:    { slidesPerView: 1.3 },
      640:  { slidesPerView: 2.2 },
      1024: { slidesPerView: 3.2 },
      1280: { slidesPerView: 4 }
    }
  });
})();

/* ── TESTIMONIAL SWIPER ──────────────── */
(function initTesti() {
  if (!document.getElementById('testiSwiper')) return;

  function animateTesti() {
    document.querySelectorAll('.testi-card').forEach(c => c.classList.remove('visible'));
    setTimeout(() => {
      document.querySelectorAll('#testiSwiper .swiper-slide-active .testi-card')
        .forEach(c => c.classList.add('visible'));
    }, 80);
  }

  new Swiper('#testiSwiper', {
    loop: true,
    speed: 800,
    autoplay: { delay: 6000, disableOnInteraction: false },
    effect: 'fade',
    fadeEffect: { crossFade: true },
    pagination: { el: '.testi-pagination', clickable: true },
    on: {
      slideChange() { animateTesti(); },
      init()        { animateTesti(); }
    }
  });
})();

/* ── SCROLL REVEAL ───────────────────── */
const revealObserver = new IntersectionObserver(entries => {
  entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
}, { threshold: 0.12 });
document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

/* ── NAV SCROLL ──────────────────────── */
window.addEventListener('scroll', () => {
  const nav = document.getElementById('main-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 10);
});

/* ── FAQ ─────────────────────────────── */
function toggleFaq(row) {
  const answer = row.nextElementSibling;
  const isOpen = row.classList.contains('open');
  document.querySelectorAll('.faq-row').forEach(r => r.classList.remove('open'));
  document.querySelectorAll('.faq-a').forEach(a => a.classList.remove('open'));
  if (!isOpen) {
    row.classList.add('open');
    answer.classList.add('open');
  }
}
/* ── GLOBAL SCROLL CONTROLLER ───────────── */

const nav = document.getElementById('main-nav');
const announce = document.querySelector("#shopify-section-announcement-bar");
const header = document.querySelector("#shopify-section-header");

window.addEventListener("scroll", () => {

  const scrolled = window.scrollY > 80;

  /* navbar background */
  if (nav) {
    nav.classList.toggle("scrolled", scrolled);
  }

  /* sticky behavior */
  if (announce && header) {
    announce.classList.toggle("scrolled-announcement", scrolled);
    header.classList.toggle("scrolled-header", scrolled);
  }

});